import { useEffect, useState } from "react";

const navLinks = [
  { href: "#top", label: "首页" },
  { href: "#map", label: "吃瓜地图" },
  { href: "#ranking", label: "热搜总榜" },
  { href: "#platforms", label: "平台入口" },
  { href: "#events", label: "最新事件" },
  { href: "#about", label: "关于吃瓜" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? "bg-background-50/85 backdrop-blur-md shadow-soft" : "bg-transparent"}`}>
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 py-3 md:px-6">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl leading-none text-foreground-950">吃瓜入口<span className="text-primary-500">网</span></span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <a key={l.href} href={l.href} className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-600">
              {l.label}
            </a>
          ))}
          <a href="#events" className="ml-2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600">
            去看今日热瓜
          </a>
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-3-line text-2xl"} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-5 pt-2 md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-primary-50 hover:text-primary-600">
                {l.label}
              </a>
            ))}
            <a href="#events" onClick={() => setOpen(false)} className="mt-1 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm text-background-50">
              去看今日热瓜
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}